import {Status, WorkflowFilter} from "./utils/types";
import {hasActiveDashboardFilters} from "./utils/dashboardFilters.helpers";
import {StarFilter} from "./star-filter/StarFilter";
import {WorkflowFilterDropdown} from "./WorkflowFilter";
import {StatusFilterDropdown} from "./StatusFilter";
import {Button, Icon, theme} from "@reside/ui";

export const DashboardFilters = ({
  onStarFilterChange,
  admissionStatus,
  onStatusSelect,
  starFilterActive,
  showWorkflowFilter,
  workflowFilter,
  workflowFilterOptions,
  onWorkflowFilterSelect,
  showStarFilter,
  showStatusFilter,
  clearFilters,
}: {
  admissionStatus: Status;
  starFilterActive: boolean;
  workflowFilter: WorkflowFilter;
  workflowFilterOptions: ReadonlyArray<WorkflowFilter>;
  onWorkflowFilterSelect: (item: WorkflowFilter) => void;
  onStarFilterChange: (isActive: boolean) => void;
  onStatusSelect: (item: Status) => void;
  showStarFilter: boolean;
  showStatusFilter: boolean;
  showWorkflowFilter: boolean;
  clearFilters: () => void;
}) => {
  const hasActiveFilters = hasActiveDashboardFilters({
    starFilterActive,
    admissionStatus,
    workflowFilter,
    showStarFilter,
    showStatusFilter,
    showWorkflowFilter,
  });

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
      }}
    >
      {showStarFilter && (
        <StarFilter
          active={starFilterActive}
          onFilterChange={onStarFilterChange}
        />
      )}
      {showWorkflowFilter && (
        <WorkflowFilterDropdown
          workflowFilter={workflowFilter}
          onWorkflowFilterSelect={onWorkflowFilterSelect}
          workflowFilterOptions={workflowFilterOptions}
        />
      )}
      {showStatusFilter && (
        <StatusFilterDropdown
          admissionStatus={admissionStatus}
          onStatusSelect={onStatusSelect}
        />
      )}
      {hasActiveFilters && (
        <Button
          style={{fontSize: theme.fontSizes[2], marginLeft: theme.space[2]}}
          type="link"
          ghost
          onClick={clearFilters}
        >
          <Icon name="close" size={12} /> Clear Filters
        </Button>
      )}
    </div>
  );
};
